import { SendEmailSmsRepository } from './SendEmailSmsRepository'
import { JtechStore } from 'src/plugins/mobx'
import ServiceRequestModel from '../../../ServiceRequestModel'

export default class SendEmailController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('SendEmailController', new SendEmailController())
  }

  async loadDatatable () {
    return await SendEmailSmsRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await SendEmailSmsRepository.loadDatatableModel(params)
  }

  async loadForm () {
    return await SendEmailSmsRepository.loadForm()
  }

  async createSendEmailSms (params) {
    return await SendEmailSmsRepository.create(params)
  }
}
